// extracted by mini-css-extract-plugin
export default {"container":"Contato_container__wxDIp","conteudo":"Contato_conteudo__fbw2z","contador":"Contato_contador__1l3Y6"};